The interval the remuneration amounts are calculated over.

Currently three interval codes are defined:

- `Hour` is used to express hourly rates.
- `Month` is used to express monthly salaries.
- `Year` is used to express annual salaries.

This field should be provided. If it is omitted, or if the supplied `interval` and `basis` are not one of the supported combinations above, the salary will not be included on the job ad.

When provided, it must correspond to `SyncPositions_RemunerationPackageInput.basis`:

- When `SyncPositions_RemunerationPackageInput.basis` equals `Hourly`, the `interval` must be `Hour`.

- When `SyncPositions_RemunerationPackageInput.basis` equals `Salaried`, the `interval` must be `Month` or `Year`.

- When `SyncPositions_RemunerationPackageInput.basis` equals `SalariedPlusCommission`, the `interval` must be `Year`.
